import { render, staticRenderFns } from "./ModalProrrogar.vue?vue&type=template&id=4ef8a8b4"
import script from "./ModalProrrogar.vue?vue&type=script&lang=ts"
export * from "./ModalProrrogar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports